import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

export function StepFooter({ onSave, busy, label = "Save & continue" }) {
  return (
    <div className="pt-2">
      <Button onClick={onSave} disabled={busy} data-testid="onboarding-save-step"
        className="bg-orange-500 hover:bg-orange-600 text-slate-900 font-semibold rounded-full px-6">
        {busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} {label}
      </Button>
    </div>
  );
}
